import React from 'react';
import { AboutPageLayout } from '../Layout';
import styles from './About.module.scss';

export const AboutMainSection = () => (
  <AboutPageLayout
    isMain
    leftContent={
      <div className={styles.leftSection}>
        <div className={styles.mainSection_1}>TransparenTerra</div>
        <div className={styles.mainSection_2}>Design</div>
        <div className={styles.mainSection_3}>ed</div>
        <div className={styles.mainSection_4}>to Restore Trust</div>
      </div>
    }
    rightContent={null}
  />
);
